import { Tooltip } from "@adeccoux/tag-ds";
import React, { createRef, ReactElement } from "react";

interface ActionsButtonsTableComponent {
  viewElement?: Function;
  editElement?: Function;
  settingsElement?: Function;
  deleteElement?: Function;
  addElement?: Function;
  index?: number;
  disabledAdd?: boolean;
  result: any;
  editElementTooltipText?: string;
  settingsElementTooltipText?: string;
  deleteElementTooltipText?: string;
}

const ActionsButtonsTable: React.FC<ActionsButtonsTableComponent> = (props): ReactElement => {
  const { viewElement, editElement, settingsElement, deleteElement, addElement, index, result, disabledAdd, editElementTooltipText, settingsElementTooltipText, deleteElementTooltipText, ...rest } =
    props;
  const _editRef: any = createRef();
  const _settingsRef: any = createRef();
  const _deleteRef: any = createRef();
  return (
    <div className="table-content table-actions" {...rest}>
      {typeof viewElement === "function" && (
        <button type="button" data-testid="details-button" className="button-interactive" onClick={() => viewElement(result)}>
          <span className="material-icons">visibility</span>
        </button>
      )}
      {typeof editElement === "function" && (
        <div>
          <button ref={_editRef} type="button" data-testid="edit-button" className="button-interactive ml1" onClick={() => editElement(result)}>
            <span className="material-icons">edit</span>
          </button>
          {editElementTooltipText && (
            <Tooltip parentRef={_editRef} placement="left">
              {editElementTooltipText}
            </Tooltip>
          )}
        </div>
      )}
      {typeof settingsElement === "function" && (
        <div>
          <button ref={_settingsRef} type="button" data-testid="edit-button" className="button-interactive ml1" onClick={() => settingsElement(result)}>
            <span className="material-icons">design_services</span>
          </button>
          {settingsElementTooltipText && (
            <Tooltip parentRef={_settingsRef} placement="left">
              {settingsElementTooltipText}
            </Tooltip>
          )}
        </div>
      )}
      {typeof deleteElement === "function" && (
        <div>
          <button ref={_deleteRef} type="button" data-testid="delete-button" className="button-interactive ml1" onClick={() => deleteElement(result)}>
            <span className="material-icons">delete</span>
          </button>
          {deleteElementTooltipText && (
            <Tooltip parentRef={_deleteRef} placement="left">
              {deleteElementTooltipText}
            </Tooltip>
          )}
        </div>
      )}
      {typeof addElement === "function" && !disabledAdd && (
        <button type="button" data-testid="details-button" className="button-interactive" onClick={() => addElement(result, index)} disabled={disabledAdd}>
          <span className="material-icons">add</span>
        </button>
      )}
    </div>
  );
};
export default ActionsButtonsTable;
